import { z } from 'zod'

const UserPermissionsTypesZ = z.enum([
	'Default',
	'ManageUsers',
	'Admin',
	'ViewOthers',
	'ManageSystem',
	'ManageApprovals',
	'ManageTrips',
	'ViewAllReports',
	'ViewManagedGroupReports',
])
export type UserPermissionsTypes = z.infer<typeof UserPermissionsTypesZ>

export interface PermissionDefs {
	every: UserPermissionsTypes[]
	oneOf: UserPermissionsTypes[]
	either: boolean
}

// eslint-disable-next-line no-restricted-syntax
export enum UserRoleNames {
	ManageBookings = 'ManageBookings',
	SupportUser = 'Support',
	Admin = 'Admin',
}

export interface PermissionRole {
	id: number
	name: UserRoleNames
	description: string
	is_admin: boolean
}
